// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"cd3e6999","223":"0eaefcdc","239":"e39fb35b","455":"47f9f60d","942":"73178e64","977":"9d626833"}[chunkId] + ".chunk.js";
};